import React from "react"
import styled from "styled-components"
import ReactDOMServer from "react-dom/server"
import { Pharmacy } from "@bw/bits"
import { breakpoints } from "../../../theme"
import maplibregl from "!maplibre-gl"
import maplibreglWorker from "maplibre-gl/dist/maplibre-gl-csp-worker"
import "maplibre-gl/dist/maplibre-gl.css"

maplibregl.workerClass = maplibreglWorker

const MapWrapper = styled.div`
  height: 202px;
  width: 100%;
  position: relative;
  background-color: var(--page-color);

  @media (min-width: ${breakpoints.medium}px) {
    height: 334px;
  }

  .map {
    position: absolute;
    width: 100%;
    height: 100%;
  }

  .maplibregl-marker {
    cursor: pointer;

    &:hover {
      filter: saturate(1.2);
    }
  }

  .pharmacyTeaser {
    a:focus {
      outline: none;
    }
  }
`

const Map = ({ allPois, filteredPois }) => {
  const mapContainer = React.useRef(null)
  const map = React.useRef(null)
  const [lat] = React.useState(46.769968)
  const [lng] = React.useState(7.991249)
  const [zoom] = React.useState(6)
  const [API_KEY] = React.useState("wtiZIOrwDwQ4lblM3hcF")
  const [markers, setMarkers] = React.useState([])

  React.useEffect(() => {
    setMarkers(
      allPois.map(poi => {
        const popup = new maplibregl.Popup()
          .setHTML(
            ReactDOMServer.renderToStaticMarkup(
              <Pharmacy
                {...poi}
                pharmacyTitle={poi.title}
                pharmacyLink={poi.slug}
                npa={poi.zipCode}
                showItinerary={false}
                more
              />
            )
          )
          .setMaxWidth("300px")

        return {
          id: poi.id,
          marker: new maplibregl.Marker({ color: "#9EBD48" })
            .setPopup(popup)
            .setLngLat([poi.longitude, poi.latitude]),
        }
      })
    )
  }, [allPois])

  React.useEffect(() => {
    if (map.current) return //stops map from intializing more than once

    map.current = new maplibregl.Map({
      container: mapContainer.current,
      style: `https://api.maptiler.com/maps/streets/style.json?key=${API_KEY}`,
      center: [lng, lat],
      zoom: zoom,
      maxZoom: 18,
    }).addControl(new maplibregl.NavigationControl(), "top-right")
  }, [API_KEY, lat, lng, zoom])

  React.useEffect(() => {
    if (filteredPois.length === 0) {
      return
    }
    const activePois = filteredPois.map(p => p.id)
    if (map.current) {
      const bounds = new maplibregl.LngLatBounds()

      filteredPois.forEach(function (p) {
        bounds.extend(new maplibregl.LngLat(p.longitude, p.latitude))
      })

      for (let i = 0; i < markers.length; i++) {
        if (activePois.includes(markers[i].id)) {
          markers[i].marker.addTo(map.current)
        } else {
          markers[i].marker.remove()
        }
      }
      map.current.fitBounds(bounds, { padding: 50 })
    }
  }, [markers, filteredPois, map])

  return (
    <MapWrapper>
      <div ref={mapContainer} className="map" />
    </MapWrapper>
  )
}

export default Map
